<script setup lang="ts">
  import { useSlots } from 'vue';

  export interface CardProps {
    /**
     * Detach the actions from the top of the card, making them absolute-positioned.
     * @default false
     */
    detachActions?: boolean;
  }

  const props = withDefaults(defineProps<CardProps>(), {
    detachActions: false,
  });

  const slots = useSlots();
</script>

<template>
  <article class="stash-card relative inline-block rounded border bg-white shadow-md" data-test="stash-card">
    <div
      v-if="slots['top-left'] || slots['top-right']"
      data-test="card-actions"
      :class="{ 'absolute top-0 w-full': props.detachActions }"
      class="flex flex-wrap items-start justify-between p-6"
    >
      <div>
        <!-- @slot Top left actions slot, for rendering content on the card top-left -->
        <slot name="top-left"></slot>
      </div>
      <div>
        <!-- @slot Top right actions slot, for rendering content on the card top-right -->
        <slot name="top-right"></slot>
      </div>
    </div>

    <div :class="{ 'mb-6 flex h-full flex-col gap-y-6': slots['default'] }">
      <!-- @slot Default slot, for rendering card subcomponents -->
      <slot></slot>
    </div>
  </article>
</template>
